import React from 'react';
import { Link } from 'react-router-dom';
import { usePageContent } from '../services/contentService';
import LoadingOverlay from '../components/LoadingOverlay';
import { impactStories } from '../data/impactStories';
import './ImpactStoriesPage.css';
import SEO from '../components/SEO';

const ImpactStoriesPage = () => {
  const { content, loading, error } = usePageContent('impact-stories');

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: window.innerWidth <= 768 ? '0 1rem' : '0 2rem'
  };

  if (loading || !content) {
    return <LoadingOverlay />;
  }

  if (error) {
    return (
      <div className="error-state">
        <p>Error loading content: {error}</p>
      </div>
    );
  }

  // Get sections from content
  const heroSection = content?.sections?.find(s => s.type === 'page-hero')?.content;
  const storiesSection = content?.sections?.find(s => s.type === 'stories-grid')?.content;

  return (
    <div className="impact-stories-page">
      <SEO
        title="Impact Stories"
        description="Read inspiring stories of young African changemakers transforming their communities with YOCILAB's support."
      />
      {/* Hero Section */}
      <div className="stories-hero-section">
        <div style={containerStyle}>
          <div className="stories-hero-content">
            <span className="section-label-small">
              {storiesSection?.sectionLabel || "IMPACT STORIES"}
            </span>
            <h1 className="stories-hero-title">
              {heroSection?.mainTitle || "Real People. Real Stories.\nReal Change."}
            </h1>
            <p className="stories-hero-subtitle">
              {heroSection?.description || "Meet the African changemakers who are transforming communities, creating solutions, and building a better future with YOCILAB's support."}
            </p>
          </div>
        </div>
      </div>

      {/* Stories Grid */}
      <div className="stories-grid-section">
        <div style={containerStyle}>
          <div className="stories-grid">
            {impactStories.map((story) => (
              <div key={story.id} className="story-grid-card">
                <div className="story-grid-image">
                  <img src={story.image} alt={story.name} />
                  <div className="story-grid-overlay">
                    <div className="story-grid-category">{story.category}</div>
                  </div>
                </div>
                <div className="story-grid-content">
                  <h3 className="story-grid-name">{story.name}</h3>
                  <p className="story-grid-role">{story.role}</p>
                  <p className="story-grid-short">{story.shortStory}</p>
                  <div className="story-grid-meta">
                    <span className="story-grid-country">{story.country}</span>
                    {story.company && (
                      <>
                        <span className="separator">•</span>
                        <span className="story-grid-company">{story.company}</span>
                      </>
                    )}
                  </div>
                  <Link
                    to={`/impact-story/${story.id}`}
                    className="story-grid-btn"
                  >
                    Read Full Story
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="stories-cta-section">
        <div style={containerStyle}>
          <div className="stories-cta-content">
            <h2>Your Story Could Be Next</h2>
            <p>Join the movement of African changemakers creating impact across the continent.</p>
            <div className="stories-cta-buttons">
              <Link to="/seed4impact" className="stories-cta-btn primary">
                Apply for Funding
              </Link>
              <Link to="/contact" className="stories-cta-btn secondary">
                Get Involved
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactStoriesPage;